import { createActions, handleActions } from 'redux-actions';
import { Map } from 'immutable';
import _, { isNumber } from 'lodash';

const initState = Map({
  blacklist: {},
  // 新的顾客名片字段配置
  attrConfig: [],
  // 新的顾客单个顾客信息
  customerAttrs: {}
});

export const {
  updateVisitorAttrs,
  updateVisitorAttrsBySocket,
  getBlacklist,
  addBlacklist,
  removeBlacklist,
  getAttrConfig,
  getCustomerAttrs,
  updateCustomerAttrs
} = createActions({
  UPDATE_VISITOR_ATTRS: (result, params) => {
    return { result, params };
  },
  UPDATE_VISITOR_ATTRS_BY_SOCKET: (result, params) => {
    return { result, params };
  },
  UPDATE_CUSTOMER_NAME: result => {
    return result;
  },
  GET_BLACKLIST: (result, trackId) => {
    const { id } = result;
    return { result: isNumber(id) && id !== 0, trackId };
  },
  ADD_BLACKLIST: (result, params) => {
    return { result, params };
  },
  REMOVE_BLACKLIST: (result, params) => {
    return { result, params };
  },
  GET_ATTR_CONFIG: result => {
    return result;
  },
  GET_CUSTOMER_ATTRS: (result, trackId) => {
    return { result: result.data, trackId };
  },
  UPDATE_CUSTOMER_ATTRS: (trackId, data) => {
    return { result: data, trackId };
  }
});

const customer = handleActions(
  {
    [updateVisitorAttrs]: (state, action) => {
      const oldCustomer = state.get('attrs');
      const { params } = action.payload;
      if (params) {
        const { attrs, trackId } = params;
        return state.set(
          'attrs',
          _.update(oldCustomer, [trackId], val => ({ ...val, ...attrs }))
        );
      }
      return state;
    },
    [updateVisitorAttrsBySocket]: (state, action) => {
      const oldCustomer = state.get('attrs');
      const { result } = action.payload;
      if (result) {
        const { attrs, trackId } = result;
        return state.set(
          'attrs',
          _.update(oldCustomer, [trackId], val => ({ ...val, ...attrs }))
        );
      }
      return state;
    },
    [getBlacklist]: (state, action) => {
      const { result, trackId } = action.payload;
      const oldCustomer = state.get('blacklist');
      return state.set('blacklist', { ...oldCustomer, ...{ [trackId]: result } });
    },
    [addBlacklist]: (state, action) => {
      const {
        params: { trackId },
        result: {
          data: { visit_black }
        }
      } = action.payload;
      const oldCustomer = state.get('blacklist') || {};
      return state.set('blacklist', { ...oldCustomer, ...{ [trackId]: visit_black } });
    },
    [removeBlacklist]: (state, action) => {
      const {
        params: { trackId }
      } = action.payload;
      const oldCustomer = state.get('blacklist');
      return state.set('blacklist', _.omit(oldCustomer, [[trackId]]));
    },
    [getAttrConfig]: (state, action) => {
      const {
        data: { attr_config_list }
      } = action.payload;
      if (attr_config_list && attr_config_list.length) {
        return state.set('attrConfig', attr_config_list);
      }
      return state;
    },
    [getCustomerAttrs]: (state, action) => {
      const { result, trackId } = action.payload;
      const oldCustomer = state.get('customerAttrs');
      return state.set('customerAttrs', { ...oldCustomer, ...{ [trackId]: result } });
    },
    [updateCustomerAttrs]: (state, action) => {
      const { result, trackId } = action.payload;
      const oldCustomer = state.get('customerAttrs');
      return state.set('customerAttrs', { ...oldCustomer, ...{ [trackId]: { ...oldCustomer[trackId], ...result } } });
    }
  },
  initState
);

export default customer;
